import { Button, CircularProgress, Container, Paper, styled, Typography } from '@mui/material';
import { ReferAndEarnPizza } from 'assets/icons/ReferAndEarnPizza';
import { palette } from 'assets/styles/colors';
import { theme } from 'assets/themes/zizzi';
import BulletPointsList from 'components/BulletPointsList';
import CopyToClipboard from 'components/CopyToClipboard';

export const StyledContainer = styled(Container)`
  ${theme.breakpoints.up('md')} {
    margin-top: 3rem;
    margin-bottom: 1rem;
  }
`;

export const StyledPaper = styled(Paper)`
  border-radius: ${theme.radius?.lg};

  ${theme.breakpoints.down('md')} {
    box-shadow: none;
  }

  ${theme.breakpoints.up('sm')} {
    padding-top: 60px;
  }

  ${theme.breakpoints.up('md')} {
    padding-top: 20px;
  }
`;

export const SubTitle = styled(Typography)`
  margin: 0.5rem 0 1rem;
`;

export const StyledBox = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 1rem 0;
  min-height: 115px;
  text-align: center;
`;

export const Code = styled(Typography)`
  font-weight: 800;
`;

export const Clipboard = styled(CopyToClipboard)`
  border: none;
  display: flex;
  border: solid 2px ${palette.blue[500]};
  border-radius: ${theme.radius.sm};
  width: 150px;
  align-items: center;
  text-align: center;
  justify-content: center;
  color: ${palette.blue[500]};
  padding: 1rem;
  margin: 1rem;

  svg {
    margin-left: 0.5rem;
    margin-top: 0;
    margin-bottom: 0;
    font-size: 1rem;
    color: ${palette.blue[500]};
  }
`;

export const Text = styled(Typography)`
  margin-top: 1rem;
`;

export const Image = styled(ReferAndEarnPizza)`
  width: 100%;
  height: 150px;
  margin: 1rem 0;

  ${theme.breakpoints.up('sm')} {
    height: 300px;
  }
`;

export const StyledBulletPointsList = styled(BulletPointsList)`
  margin-bottom: 1.5rem;
`;

export const StyledButton = styled(Button)`
  margin: 1rem 0;
  padding: 1rem 6rem;
  width: 150px;
  white-space: nowrap;
  text-align: center;

  svg {
    margin-left: 0.5rem;
  }
`;

export const Spinner = styled(CircularProgress)`
  position: relative;
  margin-top: 10px;
`;
